// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604200803/js/" + chunkId + "." + {"44":"c488397f","225":"432d2d7d","481":"9e3d836b","486":"0efc1f53","770":"7d7a0a6b"}[chunkId] + ".0.45088020528018524.chunk.js";
};